import axios from "axios";
import config from "../config/config";

const skipUrls = [config.apiName.companyCongigurationData, config.apiName.updateUserRouteMode];
const skipPaths = ["/companywiseclient"];
axios.interceptors.request.use(
  (config) => {
    // debugger;
    const currentPath = window.location.pathname;
    const shouldSkip = skipUrls.some((url) => config.url.includes(url));
    const shouldSkipByPath = skipPaths.some((path) =>
      currentPath.includes(path),
    );

    if (shouldSkip || shouldSkipByPath) return config;
    if (config.data && typeof config.data === "object") {
      if (localStorage.getItem("selectedSite")) {
        config.data = {
          ...config.data,
          siteId: JSON.parse(localStorage.getItem("selectedSite"))?.id || null,
        };
      }
    }
    return config;
  },
  (error) => Promise.reject(error),
);

export const userService = {
  loginService,
  get,
  post,
};

async function loginService(apiEndpoint, payload) {
  try {
    const response = await axios.post(apiEndpoint, payload);
    return response;
  } catch (err) {
    console.log(err);
    return null;
  }
}

async function get(apiEndpoint) {
  try {
    const response = await axios.get(apiEndpoint);
    return response;
  } catch (err) {
    return err;
  }
}

async function post(apiEndpoint, payload) {
  try {
    const response = await axios.post(apiEndpoint, payload);
    return response;
  } catch (err) {
    return err;
  }
}
